/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


 $m(document).ready(function($){
    $('.quantity_custom_click .btnqty').on('click', function(){
      var qty = parseInt($(this).parent('.quantity_custom_click').find('.quantity-input').val());
      if ($(this).hasClass('qtyplus')) {
        qty++;
      } else {
        if(qty > 1) {
          qty--;
        }
      }
      qty = (isNaN(qty))?1:qty;
      $(this).parent('.quantity_custom_click').find('.quantity-input').val(qty);
      $(this).parent('.quantity_custom_click').find('.quantity-input').attr('data-qty', qty);
  //           $('input.QuantitySelector__CurrentQuantity').val(qty);
    }); 
        
    $('.quantity_custom_click_bottom .btnqty').on('click', function(){
    var qty_select = ($(this).parent('.quantity_custom_click_bottom').find('.quantity-input').val());
                    
    if($(this).hasClass('qtyplus')) {
      qty_select++;
    }else {
      if(qty_select > 1) {
        qty_select--;
      }
    }
    qty_select = (isNaN(qty_select))?1:qty_select;
    $(this).parent('.quantity_custom_click_bottom').find('.quantity-input').val(qty_select);
    $(this).parent('.quantity_custom_click_bottom').find('.quantity-input').attr('data-quantity', qty_select);                         
  //  $('input.QuantitySelector__CurrentQuantity').val(qty_select);
    }); 


    if ($(window).width() <= 768) {
      var $buttons = $('button.Collapsible__Button.Heading.u-h6');
      if ($buttons.length) {
        $buttons.attr('aria-expanded', 'false');
      }
    }
});



 $m(document).ready(function($){
        
        $('.img_variant_Style input.ColorSwatch__Radio_custom_top').click(function(){
             var variant_val =  $(this).val(); 
          $('ul.SizeSwatchList_Style').find('input.custom_trigger_size[value="'+variant_val+'"]').trigger('click');

        });
        $('.img_variant_Style input.ColorSwatch__Radio_custom_bottom').click(function(){
             var variant_val_bottom =  $(this).val(); 
          $('ul.SizeSwatchList_Style').find('input.custom_trigger_size[value="'+variant_val_bottom+'"]').trigger('click');

        });
   
   
   
     $('.img_variant_Modelo input.ColorSwatch__Radio_custom_top').click(function(){
             var variant_val =  $(this).val(); 
          $('ul.SizeSwatchList_Modelo').find('input.custom_trigger_size[value="'+variant_val+'"]').trigger('click');

        });
        $('.img_variant_Modelo input.ColorSwatch__Radio_custom_bottom').click(function(){
             var variant_val_bottom =  $(this).val(); 
          $('ul.SizeSwatchList_Modelo').find('input.custom_trigger_size[value="'+variant_val_bottom+'"]').trigger('click');

        });
   
          
         $('input.SizeSwatch__Radio_custom_top').click(function(){
             var variant_top_size =  $(this).val(); 
          $('ul.SizeSwatchList_Size').find('input.custom_trigger_size[value="'+variant_top_size+'"]').trigger('click');

        });
         $('input.SizeSwatch__Radio_custom_bottom').click(function(){
             var variant_bottom_size =  $(this).val(); 
          $('ul.SizeSwatchList_Size').find('input.custom_trigger_size[value="'+variant_bottom_size+'"]').trigger('click');

        });
   
   
      $('input.SizeSwatch__Radio_custom_top').click(function(){
             var variant_top_size =  $(this).val(); 
          $('ul.SizeSwatchList_Tamanho').find('input.custom_trigger_size[value="'+variant_top_size+'"]').trigger('click');

        });
         $('input.SizeSwatch__Radio_custom_bottom').click(function(){
             var variant_bottom_size =  $(this).val(); 
          $('ul.SizeSwatchList_Tamanho').find('input.custom_trigger_size[value="'+variant_bottom_size+'"]').trigger('click');

        });
    
        
        $('input.colorSwatch__Radio_custom_top').click(function(){
             var variant_top_color =  $(this).val(); 
          $('.color_swatches_img_Color input.ColorSwatch__Radio[value="'+variant_top_color+'"]').trigger('click');

        });
        
        $('input.colorSwatch__Radio_custom_bottom').click(function(){
             var variant_bottom_color =  $(this).val(); 
          $('.color_swatches_img_Color input.ColorSwatch__Radio[value="'+variant_bottom_color+'"]').trigger('click');

        });
   
   
   
       $('input.colorSwatch__Radio_custom_top').click(function(){
             var variant_top_color =  $(this).val(); 
          $('.color_swatches_img_Cor input.ColorSwatch__Radio[value="'+variant_top_color+'"]').trigger('click');

        });
        
        $('input.colorSwatch__Radio_custom_bottom').click(function(){
             var variant_bottom_color =  $(this).val(); 
          $('.color_swatches_img_Cor input.ColorSwatch__Radio[value="'+variant_bottom_color+'"]').trigger('click');

        });
   
   

   
      });

$m(document).ready(function($){
      //  $(".size_swatch_Size .HorizontalList__Item:first-child .SizeSwatch__Radio_custom_top").prop('checked',true);
  //$(".size_swatch_Tamanho .HorizontalList__Item:first-child .SizeSwatch__Radio_custom_top").prop('checked',true);
        $(".img_variant_top_section .HorizontalList__Item:first-child .ColorSwatch__Radio_custom_top").prop('checked',true);
         $(".color_swatch_Color .HorizontalList__Item:first-child .colorSwatch__Radio_custom_top").prop('checked',true);
           $(".color_swatch_Cor .HorizontalList__Item:first-child .colorSwatch__Radio_custom_top").prop('checked',true);

  $('.img_bottom_section1 .HorizontalList__Item:first-child .ColorSwatch__Radio_custom_bottom').prop('checked',true);
 $('.img_bottom_section1 .HorizontalList__Item:first-child .ColorSwatch__Radio_custom_bottom').attr('checked','checked');
     var select_variant_onload = $('.two-part-1').parents('form').find('.no-js.ProductForm__Option option').attr('soldout_product');
          var select_variant2_onload = $('.two-part-2').parents('form').find('.no-js.ProductForm__Option option').attr('soldout_product');
 if(select_variant_onload){
            $('#AddToCart_cutom_top').find('span.add-tocart-btn').text('Adicionar ao carrinho');


          }
          else{
            $('#AddToCart_cutom_top').html('<span>Sold out</span>');
            $('#AddToCart_cutom_top').attr('disabled', 'true');
            $('#AddToCart_cutom_top').css('cursor', 'not-allowed');
          }
  
   if(select_variant2_onload){
            $('#AddToCart_custom_bottom').find('span.add-tocart-btn').text('Adicionar ao carrinho');


          }
          else{
            $('#AddToCart_custom_bottom').html('<span>Sold out</span>');
            $('#AddToCart_custom_bottom').attr('disabled', 'true');
            $('#AddToCart_custom_bottom').css('cursor', 'not-allowed');
          }
  
        
        $('.two-part-1 input.SizeSwatch__Radio_custom_top').click(function(){
          var el = $(this);

          $(".two-part-1 .size_swatch_Size .SizeSwatch__Radio_custom_top").removeAttr('checked');
           $(".two-part-1 .size_swatch_Tamanho .SizeSwatch__Radio_custom_top").removeAttr('checked');
          $(el).attr('checked','checked');
                    $(el).prop('checked',true);

        });
        
        $('.two-part-2 .size_swatch_Size .SizeSwatch__Radio_custom_bottom').click(function(){
          var el = $(this);

          $(".two-part-2 .size_swatch_Size .SizeSwatch__Radio_custom_bottom").removeAttr('checked');
          $(el).attr('checked','checked');
                    $(el).prop('checked',true);

        });
  
  
     $('.two-part-2 .size_swatch_Tamanho .SizeSwatch__Radio_custom_bottom').click(function(){
          var el = $(this);

          $(".two-part-2 .size_swatch_Tamanho .SizeSwatch__Radio_custom_bottom").removeAttr('checked');
          $(el).attr('checked','checked');
                    $(el).prop('checked',true);

        });
  
  
  
  
        
        $('.two-part-1 .color_swatch_Color .colorSwatch__Radio_custom_top').click(function(){
          var el = $(this);

          $(".two-part-1 .color_swatch_Color .colorSwatch__Radio_custom_top").removeAttr('checked');
          $(el).attr('checked','checked');
                    $(el).prop('checked',true);

        });
  
  
   $('.two-part-1 .color_swatch_Cor .colorSwatch__Radio_custom_top').click(function(){
          var el = $(this);

          $(".two-part-1 .color_swatch_Cor .colorSwatch__Radio_custom_top").removeAttr('checked');
          $(el).attr('checked','checked');
                    $(el).prop('checked',true);

        });
  
  
  
        
        $('.two-part-2 .img_bottom_section1 input').click(function(){
          var el = $(this);

          $(".two-part-2 .img_bottom_section1 input").removeAttr('checked');
          $(el).attr('checked','checked');
                    $(el).prop('checked',true);

        });
        
                $('.two-part-2 .color_swatch_Color .colorSwatch__Radio_custom_bottom').click(function(){
          var el = $(this);

          $(".two-part-2 .color_swatch_Color .colorSwatch__Radio_custom_bottom").removeAttr('checked');
          $(el).attr('checked','checked');
                    $(el).prop('checked',true);
     
        });
  
  $('.two-part-2 .color_swatch_Cor .colorSwatch__Radio_custom_bottom').click(function(){
          var el = $(this);

          $(".two-part-2 .color_swatch_Cor .colorSwatch__Radio_custom_bottom").removeAttr('checked');
          $(el).attr('checked','checked');
                    $(el).prop('checked',true);
     
        });
  
  
        
        $('.two-part-1 .img_variant_Style .ColorSwatch__Radio_custom_top').click(function(){
          var el = $(this);

          $(".two-part-1 .img_variant_Style .ColorSwatch__Radio_custom_top").removeAttr('checked');
          $(el).attr('checked','checked');
          $(el).prop('checked',true);
          
         

        });
  
  
      $('.two-part-1 .img_variant_Modelo .ColorSwatch__Radio_custom_top').click(function(){
          var el = $(this);

          $(".two-part-1 .img_variant_Modelo .ColorSwatch__Radio_custom_top").removeAttr('checked');
          $(el).attr('checked','checked');
          $(el).prop('checked',true);
          
         

        });
  
        
             });


 $m(function($) {
 $(document).on('click', '.two-part-1 .ProductForm__Option_custom input', function() {
   var optionValue = $(this).val();
   
     var rawItems = $('.two-part-1 .ProductForm__Option_custom');
     
       var array = [];

   
    $(rawItems).each(function(i) {
         var id = $(this).find('input[checked="checked"]').val();
         array.push(id);
       });
       var x = array.join().replace(/ /g,'');
       var y = x.replace(/,/g,'');   
   
   
       $(this).parents('form').find('.no-js.ProductForm__Option option').removeAttr('selected');    
       $(this).parents('form').find('.no-js.ProductForm__Option option[data-title="'+y+'"]').trigger('change');
       $(this).parents('form').find('.no-js.ProductForm__Option option[data-title="'+y+'"]').attr('selected', 'selected');
var get_price_new = $(this).parents('form').find('.no-js.ProductForm__Option option[data-title="'+y+'"]').attr('data-price');
   //$(this).parents('.two-part-1').find('.price_custom').text(get_price_new);
  $(this).parents('.two-part-1').find('.add-tocart-price').text(get_price_new);
 });
   
   
   $(document).on('click', '.two-part-2 .ProductForm__Option_custom input', function() {
     var optionValue = $(this).val();

     var rawItems = $('.two-part-2 .ProductForm__Option_custom');

     var array = [];


     $(rawItems).each(function(i) {
       var id = $(this).find('input[checked="checked"]').val();
       array.push(id);
     });
     var x = array.join().replace(/ /g,'');
     var y = x.replace(/,/g,'');   
     
   

     $(this).parents('form').find('.no-js.ProductForm__Option option').removeAttr('selected');    
     $(this).parents('form').find('.no-js.ProductForm__Option option[data-title="'+y+'"]').trigger('change');
     $(this).parents('form').find('.no-js.ProductForm__Option option[data-title="'+y+'"]').attr('selected', 'selected');
   var get_price_frst = $(this).parents('form').find('.no-js.ProductForm__Option option[data-title="'+y+'"]').attr('data-price');
   //$(this).parents('.two-part-2').find('.price_custom_bottom').text(get_price_frst);
   $(this).parents('.two-part-2').find('.add-tocart-price-bottom').text(get_price_frst);
   
   });
    
 });


        
      $m(document).ready(function($){
        /*addtocarttop*/
      $('.ProductForm__AddToCart_custom_top').click(function(){
         var rawItems = $('.two-part-1 .ProductForm__Option_custom');
       var array = [];

   
    $(rawItems).each(function(i) {
         var id = $(this).find('input[checked="checked"]').val();
         array.push(id);
       });
       var x = array.join().replace(/ /g,'');
       var y = x.replace(/,/g,'');   
       $(this).parents('form').find('.no-js.ProductForm__Option option').removeAttr('selected');    
       $(this).parents('form').find('.no-js.ProductForm__Option option[data-title="'+y+'"]').trigger('change');
   $(this).parents('form').find('.no-js.ProductForm__Option option[data-title="'+y+'"]').attr('selected', 'selected');
    var select_variant_sold_frst = $(this).parents('form').find('.no-js.ProductForm__Option option').attr('soldout_product');

        //quantity check
        if(select_variant_sold_frst){
            $(this).find('span.add-tocart-btn').text('Adicionar ao carrinho');


          }
          else{
            $(this).html('<span>Sold out</span>');
            $(this).attr('disabled', 'true');
            $(this).css('cursor', 'not-allowed');
          }
        
    var quantity_selector_top = $(this).parents('.two-part-1').find('.qtydiv_custom_top input.quantity_selector_top').attr('data-qty');
        
         $('input.QuantitySelector__CurrentQuantity').val(quantity_selector_top);
 
       // $('.img_variant_Style input.ColorSwatch__Radio_custom_top').trigger('click');
      $('#AddToCart').trigger('click');
      });
        
        /*addtocart-bottom*/
        $('#AddToCart_custom_bottom').click(function(){
          
           var rawItems = $('.two-part-2 .ProductForm__Option_custom');
     
       var array = [];

   
    $(rawItems).each(function(i) {
         var id = $(this).find('input[checked="checked"]').val();
         array.push(id);
       });
       var x = array.join().replace(/ /g,'');
       var y = x.replace(/,/g,'');   
       $(this).parents('form').find('.no-js.ProductForm__Option option').removeAttr('selected');    
       $(this).parents('form').find('.no-js.ProductForm__Option option[data-title="'+y+'"]').trigger('change');
 $(this).parents('form').find('.no-js.ProductForm__Option option[data-title="'+y+'"]').attr('selected', 'selected');
    var select_variant_sold = $(this).parents('form').find('.no-js.ProductForm__Option option').attr('soldout_product');

          if(select_variant_sold){
            $(this).find('span.add-tocart-btn').text('Adicionar ao carrinho');


          }
          else{
            $(this).html('<span>Sold out</span>');
            $(this).attr('disabled', 'true');
            $(this).css('cursor', 'not-allowed');
          }
        
          var quantity_selector_bottom = $(this).parents('.two-part-2').find('.qtydiv_custom_bottom input.quantity_selector_bottom').attr('data-quantity');

          $('input.QuantitySelector__CurrentQuantity').val(quantity_selector_bottom);
          
      $('#AddToCart').trigger('click');
      });
        
        //buynow btn top
        
        $('button.buy_now_btn_top').click(function(){
                             $(this).attr("disabled", "disabled");

           var rawItems = $('.two-part-1 .ProductForm__Option_custom');
     
       var array = [];

   
    $(rawItems).each(function(i) {
         var id = $(this).find('input[checked="checked"]').val();
         array.push(id);
       });
       var x = array.join().replace(/ /g,'');
       var y = x.replace(/,/g,'');   
       $(this).parents('form').find('.no-js.ProductForm__Option option').removeAttr('selected');    
       $(this).parents('form').find('.no-js.ProductForm__Option option[data-title="'+y+'"]').trigger('change');
       $(this).parents('form').find('.no-js.ProductForm__Option option[data-title="'+y+'"]').attr('selected', 'selected');
       
       //quantity check
                   var variant_n =   $(this).parents('form').find('.no-js.ProductForm__Option option:selected').val();

    var quantity_selector_top = $(this).parents('.two-part-1').find('.qtydiv_custom_top input.quantity_selector_top').attr('data-qty');
        
         $('input.QuantitySelector__CurrentQuantity').val(quantity_selector_top);
      //  $('.shopify-payment-button button.shopify-payment-button__button').trigger('click');


          
           $.ajax({

     type: 'POST',
url: '/cart/add.js',
data: {
  quantity: quantity_selector_top,
  id: variant_n
},
  dataType: 'json', 
 success: function (data) { 
        window.location.href = "/checkout";

 
 } 
 });
        });
        
        //buynow btn bottom
        
         $('button.buy_now_btn_bottom').click(function(){
                   $(this).attr("disabled", "disabled");

           var rawItems = $('.two-part-2 .ProductForm__Option_custom');
     
       var array = [];

   
    $(rawItems).each(function(i) {
         var id = $(this).find('input[checked="checked"]').val();
         array.push(id);
       });
       var x = array.join().replace(/ /g,'');
       var y = x.replace(/,/g,'');   
       $(this).parents('form').find('.no-js.ProductForm__Option option').removeAttr('selected');    
       $(this).parents('form').find('.no-js.ProductForm__Option option[data-title="'+y+'"]').trigger('change');
       $(this).parents('form').find('.no-js.ProductForm__Option option[data-title="'+y+'"]').attr('selected', 'selected');
       
           var variant_n =   $(this).parents('form').find('.no-js.ProductForm__Option option:selected').val();
         var quantity_selector_bottom = $(this).parents('.two-part-2').find('.qtydiv_custom_bottom input.quantity_selector_bottom').attr('data-quantity');

           
          $('input.QuantitySelector__CurrentQuantity').val(quantity_selector_bottom);
       // $('.shopify-payment-button button.shopify-payment-button__button').trigger('click');
   
                     

    $.ajax({

     type: 'POST',
url: '/cart/add.js',
data: {
  quantity: quantity_selector_bottom,
  id: variant_n
},
  dataType: 'json', 
 success: function (data) { 
        window.location.href = "/checkout";

 
 } 
 });
              
        });
        
      });
   

